module.exports = {
          srcSet: __webpack_public_path__ + "images/2012-ebd3e2fba80ec00e3fa90af2bdf6fd6f-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2012-36283f807a920e36ec896fc1f0d3187d-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2012-ebd3e2fba80ec00e3fa90af2bdf6fd6f-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2012-36283f807a920e36ec896fc1f0d3187d-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2012-ebd3e2fba80ec00e3fa90af2bdf6fd6f-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2012-ebd3e2fba80ec00e3fa90af2bdf6fd6f-320.jpg"},
          
          width: 320,
          height: 251
        }